<template>
  <v-dialog

      v-model="dialogStatus"
            persistent
            max-width="500px">
    <div class="fill-height">


      <v-card class="fill-height">
        <v-card-title  class="p-1">
          <v-chip
              label    small
              class="ma-2"
              color="secondary">
           فراموشی رمز
          </v-chip>
          <v-spacer/>
          <v-btn light icon @click.stop="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
<!--        <v-toolbar dense dark style="display: block"  color="#1e45c7" >-->
<!--          <v-toolbar-title>فراموشی رمز</v-toolbar-title>-->
<!--          <v-spacer/>-->
<!--          <v-btn  depressed small dark  style="background-color: #be1e0b" icon @click.stop="closed">-->
<!--            <v-icon >mdi-close</v-icon>-->
<!--          </v-btn>-->
<!--        </v-toolbar>-->

        <v-card-text>


          <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                 >
                <v-text-field
                    label="شماره موبایل"
                    outlined
                    dense
                    :error-messages="getError('mobile')"
                    v-model="mobile"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  cols="12"
                  sm="4">
                <v-flex>
                  <v-text-field
                      dense
                      label="کد"
                      placeholder="کد را وارد کنید..."
                      :error-messages="getError('codeInUser')"
                      outlined
                      v-model="codeInUser"
                  />

                </v-flex>
              </v-col>
              <v-col
                  cols="12"
                  sm="8">
                <v-flex align-self-start>
                  <vue-captcha
                      width="200"
                      ref="captcha"
                      :captcha.sync="code"
                      @on-change="handleChange">
                  </vue-captcha>
                  <v-btn   icon light @click="refresh"  color="primary">
                    <v-icon >mdi-cloud-refresh</v-icon>
                  </v-btn>


                </v-flex>
              </v-col>

            </v-row>




            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  color="primary"
                  class=" pr-10 pl-10"
                  type="submit"
                  :loading="loading"
              >
                ارسال
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Profile_se from "./Profile_se";
import VueCaptcha from "vue-captcha-code";


export default {
  components:{
    VueCaptcha
  },
  props: {
    dialogStatus: {
      default: false,
    },
  },
  data() {
    return {
      // dialogStatus:true,
      model:{},
      bindingErrors: [],
      valid: true,
      showCaptcha:false,
      loading:false,
      mobile:'',
      codeInUser:'',
      code: '',

    }
  },




  methods: {
    refresh() {
      this.$refs.captcha.refreshCaptcha();
    },
    handleChange(code) {
      this.code=code;
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors=[]
      this.$emit('update:dialogStatus', false)
    },

    save(){
      this.bindingErrors = []
      this.loading = true
        Profile_se.forgetPass(this.mobile, this.code,this.codeInUser).then(response => {
          this.loading = false
          if (response && response.status === 200) {
            this.$snack({type: 'success'})
            this.mobile=''
            this.codeInUser=''
            this.closed()
          }else if (response && response.response.status === 400) {
            this.bindingErrors = response.response.data;
            this.refresh()
          }
        })

    },



  },



}
</script>


